import "./Clients.scss";
import { Button, Tooltip } from "antd";
import { translateKey as t } from "../../../locales/translation";
import { AppStore } from "~/stores/AppStore";
import { useEffect, useMemo, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { CrudHeader } from "../_common/CrudHeader";
import { CrudFormModal } from "../_common/CrudFormModal";
import { CrudDeleteModal } from "../_common/CrudDeleteModal";
import { ClientsForm } from "./components/form/ClientsForm";
import ClientsTable from "./components/table/ClientsTable";
import { ClientsController } from "./ClientsController";
import JSONViewer from "../../../components/json_viewer/JSONViewer";

//-------------MODALS-----------------------------------
import SaveScenarioSnapshotModal from "./components/modals/Scenarios/SaveScenarioSnapshotModal";
import LoadScenarioSnapshotModal from "./components/modals/Scenarios/LoadScenarioSnapshotModal";
import DeleteScenarioSnapshotModal from "./components/modals/Scenarios/DeleteScenarioSnapshotModal";
import NewClientModal from "./components/modals/NewClient/NewClientModal";
import CloneClientModal from "./components/modals/CloneClient/CloneClientModal";
import EditClientWizardModal from "./components/modals/EditClientWizard/EditClientWizardModal";
import DemoDataPostModal from "./components/modals/DemoDataPost/DemoDataPostModal";
import ClientSettingsModal from "./components/modals/ClientSettings/ClientSettingsModal";
import CompareSettingsModal from "./components/modals/ClientSettings/CompareSettingsModal";
import DataImporterModal from "./components/modals/DataImporter/DataImporterModal";
import ResetMasterDataModal from "./components/modals/ResetMasterData/ResetMasterDataModal";
import ErrorsModal from "./components/modals/DataImporter/ErrorsModal";
import { ClientsSocketController } from "./ClientsSocketController";

const Clients = ({ store }: { store?: AppStore }) => {
  // const clientsController = new ClientsController(store);
  const clientsController = useMemo(() => new ClientsController(store), [store]);
  const clientsSocketController = useMemo(() => new ClientsSocketController(store, clientsController), [store, clientsController]);
  // Empty array [] as the dependency array, the controller is created only once, when the component mounts

  console.log("RENDER CLIENTS");

  useEffect(() => {
    clientsController.loadDependencies();
    clientsSocketController.connectSocket();
    //clientsSocketController.subscribeToDepot("clients");

    clientsController.crudCommon.enableKeyboardShortcuts();
    document.title = t("lblClients", "Clients") + " - openFleet Pro";

    window.addEventListener("beforeunload", (event) => {
      if (clientsController.modifiedRows.length > 0) {
        event.returnValue = null;
      }
    });
  }, [clientsController]);

  return (
    <div className="Clients_Main_Container">
      <CrudHeader title={t("lblClients", "Clients")} controller={clientsController} />
      <ClientsTable controller={clientsController} store={store} />

      <CrudFormModal
        controller={clientsController}
        form={<ClientsForm controller={clientsController} />}
        onClose={() => {
          if (clientsController.isSelectedReadOnly) {
            clientsController.setIsSelectedReadOnly(false);
          }
        }}
        entity="selectedClient"
        itemName={t("lblClient", "Client")}
        activeSwitch={{
          propertyAccessor: "active",
          title: t("lblActive", "Active"),
          disabled: clientsController.isReadOnly || clientsController.isSelectedReadOnly,
        }}
        centered
        canMaximize
        bodyStyle={{ padding: "0px 16px 16px 16px", maxHeight: "75vh", overflowY: "auto" }}
        size={clientsController.formModalSize}
        extraElementsInHeader={
          <Tooltip title={t("lblViewJson", "View Json")} placement="topLeft">
            <div style={{ display: "inline", marginLeft: 20 }}>
              <Button
                onClick={() => {
                  const selectedClient = clientsController.selectedClient;

                  if (clientsController?.jsonViewer?.loadModal) {
                    clientsController.jsonViewer.loadModal(selectedClient.name, selectedClient, selectedClient.name);
                  }
                }}
                icon={<FontAwesomeIcon icon={faEye} />}
                size="small"
              />
            </div>
          </Tooltip>
        }
      />

      {/* MODALS */}

      <CrudDeleteModal modalProps={clientsController.deleteModal} controller={clientsController} />
      <NewClientModal controller={clientsController} store={store} />
      <CloneClientModal controller={clientsController} store={store} />
      <EditClientWizardModal controller={clientsController} store={store} />
      <DataImporterModal controller={clientsController} store={store} />
      <ErrorsModal controller={clientsController} store={store} />
      <ResetMasterDataModal controller={clientsController} store={store} />
      <DemoDataPostModal controller={clientsController} store={store} />
      <ClientSettingsModal controller={clientsController} store={store} />
      <CompareSettingsModal controller={clientsController} store={store} />

      <SaveScenarioSnapshotModal controller={clientsController} store={store} />
      <LoadScenarioSnapshotModal controller={clientsController} store={store} />
      <DeleteScenarioSnapshotModal controller={clientsController} store={store} />

      <JSONViewer ref={(ref) => clientsController.setJsonViewer(ref)} />
    </div>
  );
};

export default Clients;
